/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Territories } from './territories';


export interface BuyoutRightFields { 
    name?: string;
    agencyNContactInfo?: string;
    role?: string;
    composerName?: string;
    publisherName?: string;
    musicCompany?: string;
    title?: string;
    contactInfo?: string;
    musicianBand?: string;
    masterRight?: string;
    publisherRights?: string;
    stockRightHolderNameNContactInfo?: string;
    type?: string;
    rightsHolder?: string;
    subLevelType?: string;
    groupCorporateLicense?: boolean;
    territories?: Array<Territories>;
}

